import { useLocation } from "react-router";

export type ClientBasePath = "/client" | "/presenter";

/**
 * Resolve the active client funnel base from the URL.
 * `/presenter/*` is the live-demo entry; everything else defaults to `/client`.
 */
export function getClientBasePath(pathname: string): ClientBasePath {
  return pathname === "/presenter" || pathname.startsWith("/presenter/")
    ? "/presenter"
    : "/client";
}

/**
 * Build a path under the active client base (e.g. `/presenter/workflow`).
 * Pass `segment` without a leading slash, or omit for the base index.
 */
export function clientPath(base: ClientBasePath, segment = ""): string {
  const trimmed = segment.replace(/^\/+/, "");
  return trimmed ? `${base}/${trimmed}` : base;
}

/**
 * Current client funnel base (`/client` or `/presenter`).
 */
export function useClientBasePath(): ClientBasePath {
  const { pathname } = useLocation();
  return getClientBasePath(pathname);
}
